/**
 * Template metadata dialog (Document No, Class, Format, Title).
 */
import React from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ReusableDialog from "../../../../components/popupModals/ReusableDialog";
import { WorkingDocumentDetailsDialogActions } from "../working-documents/dialogs/WorkingDocumentDetailsDialogActions";
import { useTheme } from "../../../../theme/OAS365Theme";
import { getTemplateDetailFields } from "./templateDetailUtils";

const labelCellStyle = {
  width: "120px",
  maxWidth: "120px",
  fontWeight: "bold",
  paddingRight: "10px",
  verticalAlign: "top",
};

const valueCellStyle = {
  wordBreak: "break-word",
  overflowWrap: "anywhere",
  verticalAlign: "top",
  minWidth: 0,
};

const TemplateDetailsDialog = ({ template, isOpen, onClose }) => {
  const theme = useTheme();
  const fields = getTemplateDetailFields(template);

  if (!isOpen) return null;

  const rows = [
    { label: "Document No", value: fields.documentNo },
    { label: "Class", value: fields.docClass },
    { label: "Format", value: fields.format },
    { label: "Title", value: fields.title },
  ];

  return (
    <ReusableDialog
      isOpen={isOpen}
      onClose={onClose}
      showHeader={false}
      variant="info"
      centerContent={false}
      dialogMinHeight={240}
      dialogMinWidth={380}
      dialogMaxWidth="min(92vw, 520px)"
      bodyMinHeight={120}
      dialogMaxHeight="95vh"
      bodyMaxHeight="65vh"
      titleContent={
        <DialogTitle
          id="template-details-dialog-title"
          sx={{
            fontWeight: 600,
            fontSize: "16px",
            fontFamily: theme.fonts.regular,
            paddingTop: "20px",
            paddingBottom: "8px",
            color: theme.colors.fontColor,
          }}
        >
          Details
        </DialogTitle>
      }
      actions={
        <WorkingDocumentDetailsDialogActions
          isDetailsComplete
          isCheckinMode={false}
          theme={theme}
          onClose={onClose}
        />
      }
    >
      <DialogContent
        sx={{
          overflowX: "hidden",
          maxWidth: "100%",
          boxSizing: "border-box",
          paddingTop: "5px",
        }}
      >
        <DialogContentText
          component="div"
          sx={{ maxWidth: "100%", width: "100%", boxSizing: "border-box" }}
        >
          <table
            style={{
              borderSpacing: "0 8px",
              borderCollapse: "separate",
              color: theme.colors.fontColor,
              fontFamily: theme.fonts.regular,
              fontSize: theme.fontSizes.normal,
              width: "100%",
              maxWidth: "100%",
              tableLayout: "fixed",
            }}
          >
            <tbody>
              {rows.map((row) => (
                <tr key={row.label}>
                  <td valign="top" style={labelCellStyle}>
                    {row.label}:
                  </td>
                  <td valign="top" style={valueCellStyle}>
                    {row.value}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </DialogContentText>
      </DialogContent>
    </ReusableDialog>
  );
};

export default TemplateDetailsDialog;
